<div
  style="overflow-y: auto"
  mdbModal
  #userTradeSummary="mdbModal"
  class="modal fade right"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myBasicModalLabel"
  aria-hidden="true"
  (close)="onClosed($event)"
>
  <div class="modal-dialog modal-fluid" role="document" *ngIf="showModal">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="showHideModal(false)">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel">{{ userProfile.fullName }} - Trade Summary</h4>
        <h4
          *ngIf="this.fiaLeftToApplyFor"
          class="modal-title w-50"
          style="text-align: right; margin-right: 25px"
          data-mdb-toggle="tooltip"
          data-mdb-placement="top"
          title="Total Applied for this year: {{ this.fiaLeftToApplyFor.totalAppliedForCurrentYear | number }}
Total Pin Balance: {{ this.fiaLeftToApplyFor.pinTotalAvailableBalance | number }}          
Pending Applications Total: {{ this.fiaLeftToApplyFor.totalAmountRequested | number }} ({{ this.fiaLeftToApplyFor.pendingAppCount }} apps)
FIA Available {{ this.fiaLeftToApplyFor.fiaAvailable | number }}"
        >
          FIA Left To Apply For: R {{ this.fiaLeftToApplyFor.amount | number }}
        </h4>
      </div>
      <div class="modal-body">
        <div *ngIf="!statCardsBusy">
          <!--Error Display-->
          <div class="col">
            <div *ngIf="showError" class="alert alert-danger text-center font-weight-bold" role="alert">
              {{ errorMsg }}
            </div>
          </div>
          <app-stats-card
            [transactionDataBundle]="statCardsTransactionDataBundle"
            [fiaAvailable]="statCardsFiaAvailable"
            [sdaAvailable]="statCardsSdaAvailable"
            [busy]="statCardsBusy"
            [userProfile]="userProfile"
          ></app-stats-card>

          <!--Grid row-->
          <div class="row wow fadeIn mt-5">
            <!--Grid column-->
            <div class="col-md-12 mb-4">
              <!--Card-->
              <mdb-card>
                <!-- Card header -->
                <!-- <div class="card-header">{{currentYear}} YTD Summary</div> -->

                <!--Card content-->
                <mdb-card-body>
                  <div class="my-2" *ngIf="!yearlySummaryBusy && traded">
                    <div class="d-block" style="height: 45vh">
                      <canvas
                        mdbChart
                        [chartType]="chart1Type"
                        [datasets]="chartDatasets"
                        [labels]="chartLabels"
                        [colors]="chartColors"
                        [options]="chartOptions"
                        [legend]="false"
                      >
                      </canvas>
                    </div>
                  </div>
                  <div class="w-100 text-center" *ngIf="!yearlySummaryBusy && !traded">
                    <img src="../../../../assets/img/FileSearch.svg" class="col-sm-2 mx-auto d-block" alt="1" />
                    <h2 class="text-center">Looks like this user hasen't traded this year yet...</h2>
                    <p>Once they've done their first trade for the year, we'll show their monthly profit summary here.</p>
                  </div>
                  <!--Loading display-->
                  <app-loading [busy]="yearlySummaryBusy"></app-loading>
                </mdb-card-body>
              </mdb-card>
              <!--/.Card-->
            </div>
            <!--Grid column-->
          </div>
          <!--Grid row-->
        </div>
        <!--Loading-->
        <div *ngIf="statCardsBusy" class="col-12 text-center">
          <div class="spinner-grow text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
